export const enum Regulation {
	International = 'international',
	Usa = 'usa'
}

export const enum ShortCode {
	CHZ = 'CHZ',
	EUR = 'EUR',
	RP = 'Reward Points',
	SSU = 'SSU',
	USD = 'USD'
}
